import { etoilesEnMots, ETOILES_MAX, motDeLEtoile } from '../partage/vocabulaire';
import './Etoiles.css';

/**
 * La difficulté en étoiles, à lire (chantier `revue-design`, ticket 01, `design/maintenant.html`) :
 * « ★★★☆☆ », lu « 3 étoiles sur 5 ». Pour la choisir, c'est `EtoilesDeDifficulte`.
 */
export function Etoiles({ charge }: { charge: number }) {
  const pleines = etoilesEnMots(charge).length;
  return (
    <span className="etoiles-lues" role="img" aria-label={motDeLEtoile(pleines)}>
      {'★'.repeat(pleines) + '☆'.repeat(Math.max(0, ETOILES_MAX - pleines))}
    </span>
  );
}
